document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll('.instructions');

  accordions.forEach(instruction => {
    const header = instruction.querySelector('.instructions__header');
    const content = instruction.querySelector('.instructions__content');
    const caret = instruction.querySelector('.icon-caret');

    content.style.overflow = 'hidden';
    content.style.transition = 'height 0.3s ease, opacity 0.3s ease';
    content.style.height = '0px';
    content.style.opacity = '0';

    header.addEventListener('click', function () {
      const isOpen = content.classList.contains('open');

      if (isOpen) {
        content.style.height = content.scrollHeight + 'px'; // Ensure current height is set
        requestAnimationFrame(() => {
          content.style.height = '0px';
          content.style.opacity = '0';
        });
      } else {
        content.style.height = content.scrollHeight + 'px';
        content.style.opacity = '1';
      }

      content.classList.toggle('open', !isOpen);
      caret.classList.toggle('rotated', !isOpen);
    });

    // Reset height after transition for auto sizing
    content.addEventListener('transitionend', function () {
      if (content.classList.contains('open')) {
        content.style.height = 'auto';
      }
    });
  });
});